import ICountry from '@models/country';
import IPaginatedParams from '@models/paginated-params';
import IPaginatedesponse from '@models/paginated-reponse';
import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

export const getCountries = (
  params: IPaginatedParams,
): Promise<AxiosResponse<IPaginatedesponse<ICountry>>> => {
  return axiosClient.get(EndPoints.country.getCountries(params));
};
